/**
 * API Configuration
 *
 * Provides centralized API base URLs for the React application.
 * These URLs are injected at build time via webpack DefinePlugin.
 *
 * Usage:
 *   import { API_BASE_URL, SHOPPING_CART_API_BASE_URL } from '@config/apiConfig';
 *   const response = await axios.get(`${API_BASE_URL}/cosmetics/my-collection`);
 *
 * Environment Variables:
 *   For Next.js builds (nextjs/.env.local):
 *     - NEXT_PUBLIC_API_BASE_URL: Base URL for general SIE API (e.g., https://api-dev1-sie.repeat.gg)
 *     - NEXT_PUBLIC_SHOPPING_CART_API_BASE_URL: Base URL for shopping cart API
 *     - NEXT_PUBLIC_SYMFONY_API_BASE_URL: Base URL for Symfony backend API
 *     - NEXT_PUBLIC_REPEAT_BASE_URL: Base URL for the Next.js app itself
 *
 *   For Symfony/React builds (symfony/.webpackEnv):
 *     - API_BASE_URL: Base URL for general SIE API (legacy, without NEXT_PUBLIC_ prefix)
 *     - SHOPPING_CART_API_BASE_URL: Shopping cart API base URL
 *     - REPEAT_BASE_URL: The Symfony backend base URL
 */
// External SIE API base URL (for cosmetics, notifications, ordering, payments, rewards, catalogue)
// Support both NEXT_PUBLIC_ (Next.js) and unprefixed (Symfony webpack) during transition
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || process.env.API_BASE_URL || '';
// Shopping cart API base URL (for cart and prize cart operations)
export const SHOPPING_CART_API_BASE_URL = process.env.NEXT_PUBLIC_SHOPPING_CART_API_BASE_URL || process.env.SHOPPING_CART_API_BASE_URL || '';
// Symfony backend API base URL (for /api/* routes and OAuth that hit the PHP backend)
// For Next.js: NEXT_PUBLIC_SYMFONY_API_BASE_URL or fallback to SYMFONY_API_BASE_URL
// For Symfony webpack: REPEAT_BASE_URL (since the backend refers to itself)
export const SYMFONY_API_BASE_URL = process.env.NEXT_PUBLIC_SYMFONY_API_BASE_URL || process.env.SYMFONY_API_BASE_URL || process.env.REPEAT_BASE_URL || '';
